<template>
  <div
    class="c-app flex-row align-items-center amsys-header"
    style="background-image: url('carbon-coal.jpg');"
  >
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard
              class="p-4"
              style="border: 0px solid;background-color: transparent;"
            >
              <CCardBody>
                <CForm @submit.prevent="submit">
                  <div class="text-center">
                    <CImg
                      src="img/logo-cde.png"
                      style="max-width:35%; text-align:center;"
                      class="img-fluid"
                    >
                    </CImg>
                  </div>
                  <h1></h1>
                  <p class="text-muted"></p>
                  <CInput
                    placeholder="Username"
                    autocomplete="username"
                    v-model="form.username"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-user" />
                    </template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="form.password"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked" />
                    </template>
                  </CInput>
                  <CRow>
                    <CCol class="text-left">
                      <CButton
                        v-on:click="submit"
                        tycolor="primary"
                        class="col-12 btn btn-primary"
                        >Login</CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
                <CRow style="margin-top:7px;">
                  <CCol class="text-center">
                    <div class="amsys-button-url">
                      <h6
                        @click.prevent="
                          () => {
                            modalUrl = true;
                          }
                        "
                        color="secondary"
                      >
                        Atur Url Server
                      </h6>
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
      <CRow class="justify-content-center">
        <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
      </CRow>
      <CRow class="justify-content-center">
        <div id="loading-contentx" v-if="loading"></div>
      </CRow>
    </CContainer>
    <CModal alignment="center" :show.sync="modalUrl">
      <h5 style="text-align: center"><b> Input Url Server</b></h5>
      <CForm @submit.prevent="submitUrl">
        <input
          class="input-field form-control form-control-lg"
          placeholder="http://yourcompanydomain.com"
          pattern="https://.*"
          v-model="urlServer"
          style="border-radius: 35px"
        />
        <CRow>
          <CCol class="text-center">
            <CButton
              v-on:click="submitUrl"
              style="
                width: 70%;
                font-size: 15px;
                border-radius: 35px;
                color: rgb(255, 255, 255);
                border-color: green;
                font-weight: bold;
                margin-top: 15px;
                padding-bottom: 0.4rem;
                padding-top: 0.4rem;
                "
              class="col-12 btn btn-primary"
            >
              OK
            </CButton>
          </CCol>
        </CRow>
      </CForm>
      <template #footer> <br /></template>
    </CModal>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import router from "vue-router";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import CryptoJS from "crypto-js";
import { string } from "yargs";
import cryptoJs from "crypto-js";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      urlServer: "",
      form: {
        username: "",
        password: "",
      },
      showError: false,
      loading: false,
      notif: false,
      modalUrl: false,
      isUrl: false,
    };
  },
  methods: {
    async submit() {
      localStorage.setItem("page", "1");
      this.loading = true;
      const stringToProtect = "Amsys_2@2021";
      const user = new FormData();
      user.append("user", this.form.username);
      user.append("password", this.form.password);
      var encryptedString = CryptoJS.AES.encrypt(
        this.form.password,
        stringToProtect
      ).toString();
      if (this.isUrl) {
        await axios
          .post(`${this.urlServer}/Auth/Token`, user)
          .then((response) => {
            if (response.data != "failed") {
              this.loading = true;
              localStorage.setItem("token", response.data); // store the token in localstorage
              localStorage.setItem("user", this.form.username);
              localStorage.setItem("pass", encryptedString); // store the token in localstorage

              axios
                .post(`${this.urlServer}/Api/General/GetAccessMenu2/`, "", {
                  headers: {
                    Authorization: "Bearer " + response.data,
                  },
                })
                .then((res) => {
                  localStorage.setItem("navigation", JSON.stringify(res.data));
                  localStorage.setItem("viewNavigation", false);
                  this.$router.push({ path: "/pages/Splash" });
                })
                .catch((error) => {
                  Vue.$toast.open({
                    message: error,
                    type: "error",
                    position: "bottom",
                  });
                });
            } else {
              Vue.$toast.open({
                message: "Invalid username or password",
                type: "error",
                position: "bottom",
              });
            }
          })
          .catch((error) => {
            Vue.$toast.open({
              message: "net:: ERR_CONNECTION_REFUSED",
              type: "error",
              position: "bottom",
            });
          })
          .finally(() => (this.loading = false));
      } else {
        this.loading = false;
        Vue.$toast.open({
          message: "Mohon isi url server terlebih dahulu",
          type: "error",
          position: "bottom",
        });
      }
    },
    submitUrl() {
      if (this.urlServer == "") {
        Vue.$toast.open({
          message: "Silahkan isi url",
          type: "error",
          position: "bottom",
        });
      } else {
        if (this.urlServer.includes("http")) {
          setTimeout(() => {
            const stringToProtect = "Amsys_2@2021";
            let encryptedString = CryptoJS.AES.encrypt(
              this.urlServer,
              stringToProtect
            ).toString();
            localStorage.setItem("url", encryptedString);
            this.modalUrl = false;
            this.isUrl = true;
          }, 200);

          Vue.$toast.open({
            message: "Server url berhasil diatur",
            type: "success",
            position: "bottom",
          });
        } else {
          Vue.$toast.open({
            message: "Format url tidak sesuai !",
            type: "error",
            position: "bottom",
          });
        }
      }
    },
  },
  beforeMount() {
    let url = localStorage.url;
    const stringToProtect = "Amsys_2@2021";
    this.isUrl = url ? true : false;
    if (this.isUrl) {
      var bytes = CryptoJS.AES.decrypt(url, stringToProtect);
      var urlDecrypt = bytes.toString(CryptoJS.enc.Utf8);
      this.urlServer = urlDecrypt;
    } else {
      this.urlServer = "";
    }
  },
  beforeCreate() {
    let data = localStorage.token;

    console.log(data);
    if (typeof data != "undefined") {
      this.$router.push({ path: "/home" });
    }
  },
};
</script>
